import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export default (props) => {
    const id = React.useId();
    const items = (props.items || []).filter((x) => !!x);
    const hasCustomEmpty = props.emptyValue !== undefined;
    const emptyValue = hasCustomEmpty ? props.emptyValue : 'null';
    const selectedValue = props.value === null ? emptyValue : props.value;
    return _jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: `form-group floating-label w-100 ${props.small && 'form-group-sm'} ${!props.inline && 'mb-3'} ${!!props.inline && 'mb-0'}` }, (props.required ? { 'required': true } : {}), { children: [_jsx("label", { htmlFor: id, className: "floating", children: props.children }), _jsxs("select", { id: id, value: selectedValue, onChange: (e) => {
                        const x = e.target.value;
                        if (hasCustomEmpty) {
                            props.onChange(x || props.emptyValue);
                        }
                        else {
                            props.onChange(x === 'null' ? null : x);
                        }
                    }, className: `form-select ${props.small && 'form-select-sm'} ${!!props.inline && 'mb-0'} ${!!props.error && 'is-invalid'}`, required: props.required || undefined, disabled: props.disabled || undefined, children: [!(props.noEmpty && !hasCustomEmpty) &&
                            _jsx("option", { value: emptyValue, children: props.emptyTitle || 'Select...' }), items.map((x) => _jsx("option", { value: props.valuef(x), children: props.titlef(x) }, props.valuef(x)))] })] })) });
};
